// AddConfigurationModal.tsx
import React from "react";
import {
  Box,
  Button,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  SelectChangeEvent,
} from "@mui/material";
import FroalaEditorComponent from "../components/Editor";
import { CustomModal } from "./CustomeModal";

interface AddConfigurationModalProps {
  open: boolean;
  onClose: () => void;
  formData: {
    cohortId: string;
    quizId: string;
    problemStatement: string;
    categoryId: string;
    teachUrl: string;
  };
  formErrors: {
    cohortId: boolean;
    quizId: boolean;
    problemStatement: boolean;
    categoryId: boolean;
    teachUrl: boolean;
  };
  categories: { id: string; name: string }[];
  onFormChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSelectChange: (event: SelectChangeEvent) => void;
  onFroalaChange: (content: string) => void;
  onSubmit: () => void;
  isSubmitting: boolean;
}

export const AddConfigurationModal: React.FC<AddConfigurationModalProps> = ({
  open,
  onClose,
  formData,
  formErrors,
  categories,
  onFormChange,
  onSelectChange,
  onFroalaChange,
  onSubmit,
  isSubmitting,
}) => {
  return (
    <CustomModal
      open={open}
      onClose={onClose}
      title="Add New Cohort Configuration"
    >
      <TextField
        label="Cohort ID"
        name="cohortId"
        value={formData.cohortId}
        onChange={onFormChange}
        fullWidth
        margin="normal"
        error={formErrors.cohortId}
        helperText={formErrors.cohortId && "Cohort ID is required"}
      />
      <TextField
        label="Quiz ID"
        name="quizId"
        value={formData.quizId}
        onChange={onFormChange}
        fullWidth
        margin="normal"
        error={formErrors.quizId}
        helperText={formErrors.quizId && "Quiz ID is required"}
      />
      <TextField
        label="Teach URL"
        name="teachUrl"
        value={formData.teachUrl}
        onChange={onFormChange}
        fullWidth
        margin="normal"
        error={formErrors.teachUrl}
        helperText={formErrors.teachUrl && "Teach URL is required"}
      />
      <FormControl fullWidth margin="normal" error={formErrors.categoryId}>
        <InputLabel>Submission Type</InputLabel>
        <Select
          name="categoryId"
          value={formData.categoryId}
          onChange={onSelectChange}
          label="Submission Type"
        >
          {categories.map((category) => (
            <MenuItem key={category.id} value={category.id}>
              {category.name}
            </MenuItem>
          ))}
        </Select>
        {formErrors.categoryId && (
          <FormHelperText>Category ID is required</FormHelperText>
        )}
      </FormControl>
      <Box mt={2}>
        <InputLabel sx={{ mb: 1 }}>Problem Statement</InputLabel>
        <FroalaEditorComponent
          value={formData.problemStatement}
          onChange={onFroalaChange}
          placeholder="Enter the problem statement..."
          height={200}
        />
        {formErrors.problemStatement && (
          <FormHelperText sx={{ color: "#d32f2f" }}>
            Problem Statement is required
          </FormHelperText>
        )}
      </Box>
      <Box justifyContent="flex-end" display="flex">
        <Button
          variant="outlined"
          color="primary"
          onClick={onSubmit}
          disabled={isSubmitting}
          sx={{ mt: 2 }}
        >
          {isSubmitting ? "Saving..." : "Submit"}
        </Button>
      </Box>
    </CustomModal>
  );
};
